/**
 * Variant Short Description
 * Updates #VariantShortDescription-{sectionId} whenever
 * the selected variant changes.
 *
 * Works with standard Shopify variant radio/select inputs
 * and the Impulse theme's product form.
 */

(function () {

  /* ── Build a map of variantId → short_description ── */
  /* We embed the data inline from Liquid (see snippet below) */
  const containers = document.querySelectorAll('[data-variant-short-description]');

  containers.forEach(function (container) {

    const sectionId   = container.dataset.sectionId;
    const productForm = document.getElementById('product-form-' + sectionId)
                     || document.querySelector('[data-section-id="' + sectionId + '"] form[data-product-form]')
                     || document.querySelector('form[data-product-form]');

    if (!productForm) return;

    /* Map built from the data attribute — set via Liquid */
    let descriptionMap = {};
    try {
      descriptionMap = JSON.parse(container.dataset.descriptions || '{}');
    } catch (e) {
      console.warn('Variant short description: invalid JSON map', e);
      return;
    }

    const descEl = document.getElementById('VariantShortDescription-' + sectionId);
    if (!descEl) return;

    /* ── Update display ── */
    function updateDescription(variantId) {
      const text = descriptionMap[String(variantId)] || '';
      descEl.innerHTML = text;

      /* Show/hide container if empty */
      descEl.style.display = text ? '' : 'none';
    }

    /* ── Listen for Shopify variant change events ── */

    /* 1. Impulse / most themes dispatch this custom event */
    productForm.addEventListener('change', function () {
      /* Read the hidden variant ID input that Shopify updates */
      const variantInput = productForm.querySelector('[name="id"]');
      if (variantInput && variantInput.value) {
        updateDescription(variantInput.value);
      }
    });

    /* 2. Also listen to the global variant:changed event
          fired by Shopify's variant-selects component */
    document.addEventListener('variant:changed', function (e) {
      if (e.detail && e.detail.variant) {
        updateDescription(e.detail.variant.id);
      }
    });

    /* 3. Impulse-specific: product:variantChange */
    document.addEventListener('product:variantChange', function (e) {
      if (e.detail && e.detail.variant) {
        updateDescription(e.detail.variant.id);
      }
    });

    /* ── Init with currently selected variant ── */
    const currentVariantInput = productForm.querySelector('[name="id"]');
    if (currentVariantInput && currentVariantInput.value) {
      updateDescription(currentVariantInput.value);
    }
  });

})();
